import { type Ctx } from '@reatom/framework';
import { getComponentDebugName as getComponentDebugNameFromNpmReact } from '@reatom/npm-react';

globalThis.DEVTOOLS = null;

export interface DevtoolsState<T = unknown> {
  (newState: T): void;
  subscribe(cb: (state: T) => void): () => void;
}

export interface Devtools {
  log(name: string, payload?: unknown): void;
  state<T>(name: string, initState: T): DevtoolsState<T>;

  show(): void;
  hide(): void;
}

export const DEVTOOLS_KEY = 'is-reatom-devtools-visible';
export const I18N_DEBUG_KEY = 'is-i18n-debug-mod-enabled';

declare global {
  var DEVTOOLS: null | Devtools;
}

export const getDevtools = () => globalThis.DEVTOOLS;

export const createDevtools = async (ctx: Ctx) => {
  if (localStorage.getItem(DEVTOOLS_KEY) === 'true') {
    const { createDevtools } = await import('@reatom/devtools');
    globalThis.DEVTOOLS = createDevtools({ ctx });
  }
};

export const getComponentDebugName = (name: string) => getComponentDebugNameFromNpmReact(name).replace('Component.', '').replace(/_/g, '');
